module.exports = __webpack_public_path__ + "img/4a4b4db.png";